export const OverloadedChannel = {
  CHAT: 'CHAT',
  VOICE_CHAT: 'VOICE_CHAT',
  CHAT_AND_VOICE_CHAT: 'CHAT_AND_VOICE_CHAT',
} as const;

export type OverloadedChannelType = typeof OverloadedChannel[keyof typeof OverloadedChannel];

export const SelectedChannel = {
  CHAT: 'CHAT',
  VOICE_CHAT: 'VOICE_CHAT',
  OPEN_REQUEST: 'OPEN_REQUEST',
} as const;

export type SelectedChannelType = typeof SelectedChannel[keyof typeof SelectedChannel];

export interface DeflectionLog {
  selectedChannel: SelectedChannelType;
  overloadedChannel: OverloadedChannelType;
}
